import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

export default class PhaseInfo extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Currency Information
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6}>
            <TextField
              required
              id="name"
              name="name"
              label="Name"
              fullWidth
              autoComplete="pname"
              value={this.props.currency.name}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.name}
              helperText={this.props.errores.name}
            />
          </Grid><Grid item xs={12} sm={6}>
            <TextField
              required
              id="symbol"
              name="symbol"
              label="Symbol"
              fullWidth
              autoComplete="pSymbol"
              value={this.props.currency.symbol}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.symbol}
              helperText={this.props.errores.symbol}
            />
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/currency/CurrencyInfo.js